// 新建班级页面
const AddClass = () =>
  import('@pv/courseSchedulCenter/divideClassManage/AddClass');

// 班级列表页面
const ClassList = () => import('@pv/courseSchedulCenter/divideClassManage/List');

// 班级详情页面
const ClassDetail = () =>
  import('@pv/courseSchedulCenter/divideClassManage/Detail');

// 班级课表页面
const ClassTimeTable = () =>
  import('@pv/courseSchedulCenter/divideClassManage/ClassTimeTable');

// 学校课表页面
const SchoolTimeTable = () =>
  import('@pv/courseSchedulCenter/divideClassTimeTable/SchoolTimeTable');

// 班级课表（走向表）
const ClassTimeTableGo = () =>
  import('@pv/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGo');
// 班级课表（走向表）详情
const ClassTimeTableGoDetail = () =>
  import('@pv/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGoDetail');
// 签到记录页面
const SignRecord = () =>
  import('@pv/courseSchedulCenter/divideClassManage/SignRecord');

// 教师课表页面
const TeacherTimeTable = () =>
  import('@pv/courseSchedulCenter/divideClassTimeTable/TeacherTimeTable');

// 学生课表页面
const StudentTimeTable = () =>
  import('@pv/courseSchedulCenter/divideClassTimeTable/StudentTimeTable');

// 考勤记录页面
const AttendanceRecord = () =>
  import('@pv/courseSchedulCenter/divideClassManage/AttendanceRecord');

// 查询学生列表页面
const StudentSearchList = () =>
  import('@pv/courseSchedulCenter/divideClassSearch/SearchList');

// 待分班学生列表页面
const DivideIntoClassStudents = () =>
  import('@pv/courseSchedulCenter/divideClassManage/DivideIntoClassStudents');
// 待分班课时列表页面
const WaitClassStudents = () =>
  import('@pv/courseSchedulCenter/divideClassManage/WaitClassStudents');

// 排课管理
const CourseSchedulList = () =>
  import('@pv/courseSchedulCenter/courseSchedulManage/CourseSchedulList');

// 智能分班页面
const SmartDivideClass = () =>
  import('@pv/courseSchedulCenter/divideClassManage/SmartDivideClass');

// 智能分班页面 - 中间空白页
const SmartDivideClassEmpty = () =>
  import('@pv/courseSchedulCenter/divideClassManage/Empty');

// 调班管理
const Shift = () => import('@pv/courseSchedulCenter/shiftManage/Shift/Index');

// 调班管理-详情
const ShiftDetail = () => import('@pv/courseSchedulCenter/shiftManage/Detail');

// 已删除班级列表页面
const DeleteClassList = () =>
  import('@pv/courseSchedulCenter/divideClassManage/DeleteClassList');

// 待结算课时数
const WaitSettlementClassHours = () =>
  import('@pv/courseSchedulCenter/divideClassManage/WaitSettlementClassHours');

export default [
  {
    path: '/courseSchedulCenter/courseSchedulManage/courseSchedulList',
    name: 'courseSchedulCenter_courseSchedulManage_courseSchedulList',
    meta: {
      title: '排课管理',
      activePath: '/courseSchedulCenter/courseSchedulManage/courseSchedulList',
      breadcrumb: '排课中心-排课管理-排课管理',
      showChangeSchool: true
    },
    component: CourseSchedulList
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list',
    name: 'courseSchedulCenter_divideClassManage_list',
    meta: {
      title: '分班管理',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理'
    },
    component: ClassList
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list/addClass',
    name: 'courseSchedulCenter_divideClassManage_list_addClass',
    meta: {
      title: '新建班级',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理-新建班级'
    },
    component: AddClass
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list/detail',
    name: 'courseSchedulCenter_divideClassManage_list_detail',
    meta: {
      title: '班级详情',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理-班级详情'
    },
    component: ClassDetail
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list/detail/classTimeTable',
    name: 'courseSchedulCenter_divideClassManage_list_detail_classTimeTable',
    meta: {
      title: '班级课表',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      activeTwoPath: '/courseSchedulCenter/divideClassManage/list/detail',
      breadcrumb: '排课中心-分班管理-分班管理-班级详情-班级课表'
    },
    component: ClassTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list/attendanceRecord',
    name: 'courseSchedulCenter_divideClassManage_list_attendanceRecord',
    meta: {
      title: '考勤记录',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理-考勤记录'
    },
    component: AttendanceRecord
  },
  {
    path: '/courseSchedulCenter/divideClassSearch/searchList',
    name: 'courseSchedulCenter_divideClassSearch_searchList',
    meta: {
      title: '按学生查询',
      activePath: '/courseSchedulCenter/divideClassSearch/searchList',
      breadcrumb: '排课中心-分班查询-按学生查询'
    },
    component: StudentSearchList
  },
  {
    path: '/courseSchedulCenter/divideClassSearch/divideIntoClassStudents',
    name: 'courseSchedulCenter_divideClassSearch_divideIntoClassStudents',
    meta: {
      title: '待分班学生',
      activePath:
        '/courseSchedulCenter/divideClassSearch/divideIntoClassStudents',
      breadcrumb: '排课中心-分班查询-待分班学生'
    },
    component: DivideIntoClassStudents
  },
  {
    path: '/courseSchedulCenter/divideClassSearch/waitClassStudents',
    name: 'courseSchedulCenter_divideClassSearch_waitClassStudents',
    meta: {
      title: '待入班课时数',
      activePath: '/courseSchedulCenter/divideClassSearch/waitClassStudents',
      breadcrumb: '排课中心-分班查询-待入班课时数'
    },
    component: WaitClassStudents
  },

  {
    path: '/courseSchedulCenter/divideClassTimeTable/teacherTimeTable',
    name: 'courseSchedulCenter_divideClassTimeTable_teacherTimeTable',
    meta: {
      title: '教师课表',
      activePath: '/courseSchedulCenter/divideClassTimeTable/teacherTimeTable',
      breadcrumb: '排课中心-分班课表-教师课表',
      showChangeSchool: true // 显示切换学校按钮
    },
    component: TeacherTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassTimeTable/teacherTimeTable/classTimeTable',
    name: 'courseSchedulCenter_divideClassTimeTable_teacherTimeTable_classTimeTable',
    meta: {
      title: '班级课表',
      activePath: '/courseSchedulCenter/divideClassTimeTable/teacherTimeTable',
      breadcrumb: '排课中心-分班管理-教师课表-班级课表'
    },
    component: ClassTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassTimeTable/studentTimeTable',
    name: 'courseSchedulCenter_divideClassTimeTable_studentTimeTable',
    meta: {
      title: '学生课表',
      activePath: '/courseSchedulCenter/divideClassTimeTable/studentTimeTable',
      breadcrumb: '排课中心-分班课表-学生课表',
      showChangeSchool: true // 显示切换学校按钮
    },
    component: StudentTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassTimeTable/studentTimeTable/classTimeTable',
    name: 'courseSchedulCenter_divideClassTimeTable_studentTimeTable_classTimeTable',
    meta: {
      title: '班级课表',
      activePath: '/courseSchedulCenter/divideClassTimeTable/studentTimeTable',
      breadcrumb: '排课中心-分班管理-学生课表-班级课表'
    },
    component: ClassTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGo',
    name: 'courseSchedulCenter_divideClassTimeTable_ClassTimeTableGo',
    meta: {
      title: '班级课表（走向表）',
      activePath: '/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGo',
      breadcrumb: '排课中心-分班课表-班级课表（走向表）',
      showChangeSchool: true // 显示切换学校按钮
    },
    component: ClassTimeTableGo
  },
  // {
  //   path: '/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGoDetail',
  //   name: 'courseSchedulCenter_divideClassTimeTable_ ClassTimeTableGoDetail',
  //   meta: {
  //     title: '班级课表（走向表）详情',
  //     activePath:
  //       '/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGoDetail',
  //     breadcrumb: '排课中心-分班课表-班级课表（走向表）详情'
  //   },
  //   component: ClassTimeTableGoDetail
  // },

  {
    path: '/courseSchedulCenter/divideClassTimeTable/schoolTimeTable',
    name: 'courseSchedulCenter_divideClassTimeTable_schoolTimeTable',
    meta: {
      title: '学校课表',
      activePath: '/courseSchedulCenter/divideClassTimeTable/schoolTimeTable',
      breadcrumb: '排课中心-分班课表-学校课表',
      showChangeSchool: true // 显示切换学校按钮
    },
    component: SchoolTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassTimeTable/schoolTimeTable/classTimeTable',
    name: 'courseSchedulCenter_divideClassTimeTable_schoolTimeTable_classTimeTable',
    meta: {
      title: '班级课表',
      activePath: '/courseSchedulCenter/divideClassTimeTable/schoolTimeTable',
      breadcrumb: '排课中心-分班管理-学校课表-班级课表'
    },
    component: ClassTimeTable
  },
  {
    path: '/courseSchedulCenter/divideClassManage/SignRecord',
    name: 'courseSchedulCenter_divideClassManage_signRecord',
    meta: { title: '签到记录' },
    component: SignRecord
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list/smartDivideClass',
    name: 'courseSchedulCenter_divideClassManage_list_smartDivideClass',
    meta: {
      title: '智能分班',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理-智能分班'
    },
    component: SmartDivideClass
  },
  {
    path: '/courseSchedulCenter/divideClassManage/list/smartDivideClassEmpty',
    name: 'courseSchedulCenter_divideClassManage_list_smartDivideClassEmpty',
    meta: {
      title: '智能分班',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理-智能分班'
    },
    component: SmartDivideClassEmpty
  },
  {
    path: '/courseSchedulCenter/shiftManage/shift',
    name: 'courseSchedulCenter_shiftManage_shift',
    meta: {
      title: '调班管理',
      activePath: '/courseSchedulCenter/shiftManage/shift',
      breadcrumb: '排课中心-调班管理-调班管理'
    },
    component: Shift
  },
  // {
  //   path: '/courseSchedulCenter/shiftManage/shift/detail',
  //   name: 'courseSchedulCenter_shiftManage_shift_detail',
  //   meta: {
  //     title: '调班明细',
  //     activePath: '/courseSchedulCenter/shiftManage/shift',
  //     breadcrumb: '排课中心-调班管理-调班管理-调班明细'
  //   },
  //   component: ShiftDetail
  // },
  {
    path: '/courseSchedulCenter/divideClassManage/deleteClassList',
    name: 'courseSchedulCenter_divideClassManage_deleteClassList',
    meta: {
      title: '已删除班级',
      activePath: '/courseSchedulCenter/divideClassManage/deleteClassList',
      breadcrumb: '排课中心-分班管理-已删除班级'
    },
    component: DeleteClassList
  },
  {
    path: '/courseSchedulCenter/divideClassManage/deleteClassList/attendanceRecord',
    name: 'courseSchedulCenter_divideClassManage_deleteClassList_attendanceRecord',
    meta: {
      title: '考勤记录',
      activePath: '/courseSchedulCenter/divideClassManage/deleteClassList',
      breadcrumb: '排课中心-分班管理-已删除班级-考勤记录'
    },
    component: AttendanceRecord
  },
  {
    path: '/courseSchedulCenter/divideClassManage/deleteClassList/detail',
    name: 'courseSchedulCenter_divideClassManage_deleteClassList_detail',
    meta: {
      title: '班级详情',
      activePath: '/courseSchedulCenter/divideClassManage/deleteClassList',
      breadcrumb: '排课中心-分班管理-已删除班级-班级详情'
    },
    component: ClassDetail
  },
  {
    path: '/eduCenter/studentAttance/Index/attendanceRecord',
    name: 'eduCenter_studentAttance_Index_attendanceRecord',
    meta: {
      title: '考勤记录',
      activePath: '/eduCenter/studentAttance/Index',
      breadcrumb: '教务中心-学生考勤-学生考勤-考勤记录'
    },
    component: AttendanceRecord
  },
  {
    path: '/courseSchedulCenter/divideClassSearch/waitSettlementClassHours',
    name: 'courseSchedulCenter_divideClassSearch_waitSettlementClassHours',
    meta: {
      title: '待绑定账单课时',
      activePath: '/courseSchedulCenter/divideClassSearch/waitSettlementClassHours',
      breadcrumb: '排课中心-分班查询-待绑定账单课时'
    },
    component: WaitSettlementClassHours
  }
];
